import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactFrecventaComponent } from './contact-frecventa.component';
import { AddContactFrecventaComponent } from './add-contact-frecventa/add-contact-frecventa.component';
import { EditContactFrecventaComponent } from './edit-contact-frecventa/edit-contact-frecventa.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        ContactFrecventaComponent,
        AddContactFrecventaComponent,
        EditContactFrecventaComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [ContactFrecventaComponent],
})
export class ContactFrecventaModule { }
